/* eslint-disable */
/* eslint-disable quotes */

// ref: https://github.com/missive/emoji-mart/blob/main/packages/emoji-mart-data/i18n/en.json

export default {
  search: 'Haku',
  search_no_results_1: 'Harmi!',
  search_no_results_2: 'Emojia ei löytynyt',
  pick: 'Valitse emoji…',
  add_custom: 'Lisää mukautettu emoji',
  categories_activity: 'Harrastukset',
  categories_custom: 'Mukautettu',
  categories_flags: 'Liput',
  categories_foods: 'Ruoka ja juoma',
  categories_frequent: 'Usein käytetyt',
  categories_nature: 'Eläimet ja luonto',
  categories_objects: 'Esineet',
  categories_people: 'Hymiöt ja ihmiset',
  categories_places: 'Matkailu ja paikat',
  categories_search: 'Hakutulokset',
  categories_symbols: 'Symbolit',
  skins_choose: 'Valitse oletusihonväri',
  skins_1: 'Oletus',
  skins_2: 'Vaalea',
  skins_3: 'Keskivaalea',
  skins_4: 'Keskitaso',
  skins_5: 'Keskitumma',
  skins_6: 'Tumma',
};

// @key: @#@"search"@#@ @source: @#@"Search"@#@
// @key: @#@"search_no_results_1"@#@ @source: @#@"Oh no!"@#@
// @key: @#@"search_no_results_2"@#@ @source: @#@"That emoji couldn’t be found"@#@
// @key: @#@"pick"@#@ @source: @#@"Pick an emoji…"@#@
// @key: @#@"add_custom"@#@ @source: @#@"Add custom emoji"@#@
// @key: @#@"categories_activity"@#@ @source: @#@"Activity"@#@
// @key: @#@"categories_custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"categories_flags"@#@ @source: @#@"Flags"@#@
// @key: @#@"categories_foods"@#@ @source: @#@"Food & Drink"@#@
// @key: @#@"categories_frequent"@#@ @source: @#@"Frequently used"@#@
// @key: @#@"categories_nature"@#@ @source: @#@"Animals & Nature"@#@
// @key: @#@"categories_objects"@#@ @source: @#@"Objects"@#@
// @key: @#@"categories_people"@#@ @source: @#@"Smileys & People"@#@
// @key: @#@"categories_places"@#@ @source: @#@"Travel & Places"@#@
// @key: @#@"categories_search"@#@ @source: @#@"Search Results"@#@
// @key: @#@"categories_symbols"@#@ @source: @#@"Symbols"@#@
// @key: @#@"skins_choose"@#@ @source: @#@"Choose default skin tone"@#@
// @key: @#@"skins_1"@#@ @source: @#@"Default"@#@
// @key: @#@"skins_2"@#@ @source: @#@"Light"@#@
// @key: @#@"skins_3"@#@ @source: @#@"Medium-Light"@#@
// @key: @#@"skins_4"@#@ @source: @#@"Medium"@#@
// @key: @#@"skins_5"@#@ @source: @#@"Medium-Dark"@#@
// @key: @#@"skins_6"@#@ @source: @#@"Dark"@#@
